// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1-o3V{margin-bottom:1.5rem;-ms-flex:100% 1;flex:100% 1}@media(min-width:768px){._21Nqp{width:35.5rem}}@media(min-width:768px){._3sd8d{height:calc(43.3rem - 73px)}}", ""]);
// Exports
exports.locals = {
	"comment": "_1-o3V",
	"root": "_21Nqp",
	"content": "_3sd8d"
};
module.exports = exports;
